import http from '@/shared/api/http'

export async function getAllRoles() {
  return (await http.get('admin/roles')).data
}

export async function getRoleById(roleId) {
  return (await http.get(`admin/roles/${roleId}`)).data
}

export async function getRolePermissions(roleId) {
  return (await http.get(`admin/roles/${roleId}/permissions`)).data
}

export async function createRole(roleData) {
  return (await http.post('admin/roles', roleData)).data
}

export async function updateRole(roleId, roleData) {
  return (await http.put(`admin/roles/${roleId}`, {
    roleId: roleId,
    name: roleData.name
  })).data
}

export async function deleteRole(roleId) {
  return (await http.delete(`admin/roles/${roleId}`)).data
}

export async function assignPermissionToRole(roleId, permissionId) {
  return (await http.post(`admin/roles/${roleId}/permissions/${permissionId}`)).data
}

export async function removePermissionFromRole(roleId, permissionId) {
  return (await http.delete(`admin/roles/${roleId}/permissions/${permissionId}`)).data
}